import { EMPTY_OBJECT } from '../../../constants/common'
import { filterVisibleItems } from '../../../utils/common'

import {
  CHANGE_VIEW_TYPE_SCREEN_MIN_WIDTH,
  TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE,
} from './TableControlButtons.constants'
import { getTableViewRegimeOptions } from './TableViewRegimeControl'

// A disabled control keeps the reason its tooltip gives on the desktop toolbar.
function getControlOptionTooltipContent({ buttonProps, t }) {
  return buttonProps?.disabled && buttonProps.tooltip
    ? t(buttonProps.tooltip)
    : null
}

function getChangeViewTypeOptions(
  {
    changeViewTypeButtonProps: { onChange, ...regimeProps } = EMPTY_OBJECT,
    disabled,
    isVisible,
  },
  t
) {
  return getTableViewRegimeOptions(regimeProps).map(option => ({
    disabled,
    isVisible: isVisible && !option.isActive,
    label: t(option.label),
    value: `${TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE.changeViewType}-${option.value}`,
    onClick: () => onChange(option.value),
  }))
}

export function getShowChangeViewTypeButton({
  ChangeViewTypeButton,
  keepOnNarrowScreen,
  screenWidth,
}) {
  return (
    Boolean(ChangeViewTypeButton) &&
    (Boolean(keepOnNarrowScreen) ||
      screenWidth > CHANGE_VIEW_TYPE_SCREEN_MIN_WIDTH)
  )
}

export function getTableControlButtonsActionsSelectOptions(
  {
    ChangeViewTypeButton,
    ConfigButton,
    DensityButton,
    RefreshButton,
    ResetSortingButton,
    changeViewTypeButtonProps,
    configButtonProps,
    densityButtonProps,
    disabled,
    refreshButtonProps,
    resetSortingProps,
  },
  t
) {
  return filterVisibleItems([
    {
      disabled: resetSortingProps?.disabled ?? disabled,
      isVisible: Boolean(ResetSortingButton),
      label: t('Table.ResetSortingBtnKey'),
      tooltipContent: getControlOptionTooltipContent({
        buttonProps: resetSortingProps,
        t,
      }),
      value: TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE.resetSorting,
      onClick: resetSortingProps?.onClick,
    },
    {
      disabled:
        refreshButtonProps?.isLoading ||
        (refreshButtonProps?.disabled ?? disabled),
      isVisible: Boolean(RefreshButton),
      label: t('Table.RefreshBtnKey'),
      value: TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE.refresh,
      onClick: refreshButtonProps?.onClick,
    },
    {
      disabled: densityButtonProps?.disabled ?? disabled,
      isVisible: Boolean(DensityButton),
      label: t('Table.DensityBtnKey'),
      tooltipContent: getControlOptionTooltipContent({
        buttonProps: densityButtonProps,
        t,
      }),
      value: TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE.density,
      onClick: densityButtonProps?.onClick,
    },
    {
      disabled: configButtonProps?.disabled ?? disabled,
      isVisible: Boolean(ConfigButton),
      label: t('Table.EditBtnKey'),
      tooltipContent: getControlOptionTooltipContent({
        buttonProps: configButtonProps,
        t,
      }),
      value: TABLE_CONTROL_BUTTONS_ACTIONS_SELECT_OPTION_VALUE.config,
      onClick: configButtonProps?.onClick,
    },
    ...getChangeViewTypeOptions(
      {
        changeViewTypeButtonProps,
        disabled,
        isVisible: Boolean(ChangeViewTypeButton),
      },
      t
    ),
  ])
}
